module.exports = __webpack_public_path__ + "static/media/2.27c4b40f.svg";